import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useInView, reveal } from '../home/motion';
import { useT } from '../../i18n/LanguageContext';

export default function MethodPhilosophy() {
  const theme = useTheme();
  const t = useT();
  const { ref, visible } = useInView();

  return (
    <Box sx={{ bgcolor: theme.home.ink, py: theme.home.sectionPy }}>
      <Box ref={ref} sx={{ maxWidth: 760, mx: 'auto', px: { xs: 3, md: 5 }, textAlign: 'center' }}>
        <Typography variant="overline" sx={{ color: theme.home.cyan, ...reveal(visible) }}>
          {t('method.philosophy.eyebrow')}
        </Typography>
        <Typography variant="h2" sx={{
          mt: 1.5, color: theme.home.paper, fontSize: { xs: '1.9rem', md: '2.5rem' }, ...reveal(visible, 0.08),
        }}>
          {t('method.philosophy.title')}
        </Typography>
        <Typography sx={{
          mt: 2.5, color: 'rgba(251,248,244,0.75)', fontSize: '1.1rem', lineHeight: 1.7, ...reveal(visible, 0.16),
        }}>
          {t('method.philosophy.body')}
        </Typography>
      </Box>
    </Box>
  );
}
